export const ShareUrlRenditions = {
    Small: 'downsized',
    Social: 'downsized_large',
    Original: 'original',
    OriginalStill: 'original_still',
    MP4: 'original_mp4',
} as const

export type ShareUrlRenditionType = (typeof ShareUrlRenditions)[keyof typeof ShareUrlRenditions]
